import {isEmpty} from "./helpers";
import moment from 'jalali-moment'

const $monthsName = {1: 'فروردین', 2: 'اردیبهشت', 3: 'خرداد', 4: 'تیر', 5: 'مرداد', 6: 'شهریور', 7: 'مهر', 8: 'آبان', 9: 'آذر', 10: 'دی', 11: 'بهمن', 12: 'اسفند'};
const $daysName = {0: 'یکشنبه', 1: 'دوشنبه', 2: 'سه شنبه', 3: 'چهارشنبه', 4: 'پنجشنبه', 5: 'جمعه', 6: 'شنبه'};

export function getCurrentTime(add = 0) {
    return Math.floor(Date.now() / 1000) + add;
}

export function getCurrentYear(jalali = true) {
    let year = new Date().getFullYear();

    if (jalali) {
        year = year - 622; // convert
    }

    return year;
}

export function getMonthsName($monthNumber = null) {
    if (!isEmpty($monthNumber) && $monthNumber > 0 && $monthNumber < 13) {
        return $monthsName[$monthNumber];
    }

    if (isEmpty($monthNumber)) {
        return $monthsName;
    }

    return null;
}

export function convertDateToTimestamp(date) {
    moment.locale('fa');
    return moment(date, 'YYYY/M/D').unix();
}

export function convertTimestampToDate(timestamp) {
    moment.locale('fa');
    return moment.unix(timestamp).format('YYYY/M/D');
}